import React, { Component } from 'react';
import { withRouter }             from 'react-router';
import { connect }                from 'react-redux';
import { ClipLoader }             from 'react-spinners';
import { BootstrapTable }         from 'react-bootstrap-table';
import { TableHeaderColumn }      from 'react-bootstrap-table';
import { MdVisibilityOff }        from 'react-icons/md';
import { MdVisibility }           from 'react-icons/md';
import { FaQuestion }             from 'react-icons/fa';
import BSU                        from '../../../../images/bsu-dns.png';
import Amazon                     from '../../../../images/amazon-dns.png';
import { UrlShortenerConstants }  from '../environment';
import { listFetchData }          from '../../../../actions/pubsub/list';
import { isLoggedIn, attachAuth } from '../../../../utils/authService';

var apiHost = UrlShortenerConstants.WebApiHost;

class List extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      loading : false,
      items   : [],
      dns     : {}
    };    
    
    this.onAddRow      = this.onAddRow.bind(this);
    this.onRowClick    = this.onRowClick.bind(this);
    this.onDeleteRow   = this.onDeleteRow.bind(this);
    this.onCampus      = this.onCampus.bind(this);
    this.disableFormat = this.disableFormat.bind(this);
    this.dnsFormat     = this.dnsFormat.bind(this);
  }
  
  onAddRow(obj) {
    var params = {
      target: obj.Target,
      source: obj.Source,
      disabled: obj.Disabled === 'true'
    };
    
    obj.Disabled = params.disabled;
    fetch(apiHost + 'url/add', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        promise.json()
          .then(result => {
            var items = this.state.items.slice().filter(function(o) {
              return o.Source !== obj.Source;
            });
            
            items.push(obj);
            this.setState({ items: items });
          });
    });
  }
  
  onDeleteRow(obj) {
    var params = {
      source: obj[0]
    };

    fetch(apiHost + 'url/remove', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        promise.json()
          .then(result => {

          });
    });
  }
  
  onRowClick(obj) {
    var cont = false;
    if (obj.Disabled) {
      if (window.confirm(`Are you sure you want to enable ${obj.Source}?`)) {
        cont = true;
      }
    }
    else {
      if (window.confirm(`Are you sure you want to disable ${obj.Source}?`)) {
        cont = true;
      }
    }
    
    if (cont) {
      var params = {
        source: obj.Source,
        disabled: !obj.Disabled
      };

      fetch(apiHost + 'url/disable', {
        method: 'post',
        body: JSON.stringify(params),
        headers: attachAuth()
      }).then(promise => {
        promise.json()
          .then(result => {
            var items = this.state.items.slice();
            for (var i = 0, l = items.length; i < l; i++) {
              if (items[i].Source === obj.Source) {
                items[i].Disabled = !obj.Disabled;
                break;
              }
            }
            
            this.setState({ items: items });
          });
      });
    }
  }
  
  onDnsClick(obj) {
    var params = {
      source: obj.Source,
    };

    fetch(apiHost + 'url/dns', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
      promise.json()
          .then(result => {
            const dns = Object.assign({}, this.state.dns);
            dns[obj.Target.replace(/\//g, '').replace(/:/g, '')] = result.ip;
            this.setState({ dns: dns });
          });
      });
  }
  
  onAfterSaveCell(row, cellName, cellValue) {
    var params = {
      target : row.Target,
      source : row.Source,
      notes  : row.Notes
    };
      
    fetch(apiHost + 'url/edit', {
        method: 'post',
        body: JSON.stringify(params),
        headers: attachAuth()
      }).then(promise => {
        promise.json()
          .then(result => {
            
          });
      });
  }
  
  onCampus(key) {
    if (key.startsWith("132.178")) {
      return <img src={BSU} alt="BSU" width={25} height={25} />;
    }
    else {
      return <img src={Amazon} alt="Amazon" width={25} height={25} />;
    }
  }
  
  customConfirm(next, dropRowKeys) {
    const dropRowKeysStr = dropRowKeys.join(',');
    if (window.confirm(`Are you sure you want to delete ${dropRowKeysStr}?`)) {
      // If the confirmation is true, call the function that
      // continues the deletion of the record.
      next();
    }
  }
  
  disableFormat(cell, row) {
    return <button onClick={() => this.onRowClick(row)}>
            { cell ?
                <MdVisibilityOff size={24} />
              : <MdVisibility    size={24} />
            } 
          </button>;
  }
  
  dnsFormat(cell, row) {
    var key = row.Target.replace(/\//g, '').replace(/:/g, '');
    return <button onClick={() => this.onDnsClick(row)}>
            { this.state.dns[key] ?
                this.onCampus(this.state.dns[key])
              : <FaQuestion size={18} />
            } 
          </button>;
  }

  componentDidMount() {
    this.setState({ loading: true });
    fetch(apiHost + 'url/list', {
      method: 'get',
      headers: attachAuth()
    }).then(promise => {
        promise.json()
          .then(result => {
            this.setState({ items: result, loading: false });
          });
      });
  }

  render() {
    let content = null;
    if (isLoggedIn()) {
      const selectRow = {
        mode: 'radio' //radio or checkbox
      };

      const cellEditProp = {
        mode: 'click',
        blurToSave: true,
        afterSaveCell: this.onAfterSaveCell  // a hook for after saving cell
      };
      
      const options = {
        onAddRow               : this.onAddRow,
        onDeleteRow            : this.onDeleteRow,
        handleConfirmDeleteRow : this.customConfirm,
      };
      
      content = 
          <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '95%' }}>
            <BootstrapTable tableBodyClass="catalog-bootstrap-table" data={this.state.items} striped={true} hover={true} search deleteRow insertRow editRow selectRow={ selectRow } options={ options } cellEdit={ cellEditProp }>
              <TableHeaderColumn dataField="Source" isKey={true} dataSort={true} width={'30%'}>Source</TableHeaderColumn>
              <TableHeaderColumn dataField="Target" dataSort={true} width={'30%'}>Target</TableHeaderColumn>
              <TableHeaderColumn dataField="Notes" dataSort={false} width={'20%'}>Notes</TableHeaderColumn>
              <TableHeaderColumn dataField="Disabled" dataFormat={ this.disableFormat } width={'10%'} editable={ false }>Disable</TableHeaderColumn>
              <TableHeaderColumn dataField="Dns" dataFormat={ this.dnsFormat } width={'10%'} editable={ false }>Dns</TableHeaderColumn>
            </BootstrapTable>
          </div>;
    }

    return (
      <div>
        <div>
          {content}
        </div>
        :
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          <ClipLoader
            color={'#072659'}
            loading={this.state.loading}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.pubsub.list.list,
    hasErrored: state.pubsub.list.listHasErrored,
    isLoading: state.pubsub.list.listIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host) => dispatch(listFetchData(host))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(List));
